<template>
  <NormalFcont118Jp v-if="isJpTemplate" />
  <NormalFcont118Ww v-else />
</template>

<script>
import { mapGetters } from "vuex";
import NormalFcont118Jp from './normal_fcont_118_jp'
import NormalFcont118Ww from './normal_fcont_118_ww'


export default {
  name: 'app',
  components: {
    NormalFcont118Jp,NormalFcont118Ww
  },

  metaInfo() {
    return {
      title: this.$store.state.messages.messages['118-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['118-51']}
    ]};
  },
  computed: {
    ...mapGetters(["isJpTemplate"]),
  }

};
</script>
<style >

</style>

